import _ from 'lodash';
import React from 'react';
import { Label } from 'semantic-ui-react';
import { defineMessages, injectIntl } from 'react-intl';
import ProgressLabel from 'components/shared/ProgressLabel';

const messages = defineMessages({
  'historical': {
    id: 'alertMapping.columns.status.historical',
    defaultMessage: 'Historical'
  },
  'live': {
    id: 'alertMapping.columns.status.live',
    defaultMessage: 'Live'
  },
  'complete': {
    id: 'alertMapping.columns.status.complete',
    defaultMessage: 'Complete'
  },
  'error': {
    id: 'alertMapping.columns.status.error',
    defaultMessage: 'Error'
  }
});

const StatusColumn = ({
  state,
  intl: {
    formatMessage
  }
}) => {
  if (!state) {
    return null;
  };
  switch (state.state) {
    case 'historical':
      return (
        <ProgressLabel
          content={formatMessage(messages['historical'])}
          color='yellow'
          percent={_.chain(state.history)
            .findLast(['type', 'progress'])
            .get('settings.percentage')
            .toNumber()
            .value() || 0} />
      );
    case 'live':
      return (
        <Label
          color='green'
          content={formatMessage(messages['live'])} />
      );
    case 'complete':
      return (
        <Label
          content={formatMessage(messages['complete'])} />
      );
    case 'error':
      return (
        <Label
          color='red'
          content={formatMessage(messages['error'])}
          detail={_.chain(state.history)
            .findLast(['type', 'error'])
            .get('settings.message')
            .value()} />
      );
    default:
      return null;
  };
};

StatusColumn.displayName = 'StatusColumn';

export default injectIntl(StatusColumn);